import Button from '../../components/ui/Button';
import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';

const WeeklyReports = () => {
  const weeklyData = [
    { day: 'Sun', customers: 45, products: 30, stock: 25, outOfStock: 5, revenue: 180 },
    { day: 'Mon', customers: 52, products: 35, stock: 28, outOfStock: 7, revenue: 220 },
    { day: 'Tue', customers: 48, products: 32, stock: 26, outOfStock: 6, revenue: 200 },
    { day: 'Wed', customers: 55, products: 38, stock: 30, outOfStock: 8, revenue: 250 },
    { day: 'Thu', customers: 52, products: 35, stock: 28, outOfStock: 7, revenue: 230 },
    { day: 'Fri', customers: 49, products: 33, stock: 27, outOfStock: 6, revenue: 210 },
    { day: 'Sat', customers: 46, products: 31, stock: 25, outOfStock: 6, revenue: 190 }
  ];

  const userActivityData = [
    { time: '0', users: 12 },
    { time: '5', users: 8 },
    { time: '10', users: 15 },
    { time: '15', users: 22 },
    { time: '20', users: 18 },
    { time: '25', users: 25 },
    { time: '30', users: 21 }
  ];

  const countryData = [
    { country: 'US', value: 30, change: 25.8, flag: '/images/img_us_copy.svg', positive: true },
    { country: 'Brazil', value: 30, change: 15.8, flag: '/images/img_br.svg', positive: false },
    { country: 'Australia', value: 25, change: 35.8, flag: '/images/img_as.svg', positive: true }
  ];

  return (
    <section className="flex flex-col lg:flex-row gap-5 w-full">
      {/* Weekly Report Chart */}
      <div className="flex flex-col w-full lg:w-[70%] bg-background-card rounded-base shadow-[0px_1px_3px_#00000033] p-5">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-5">
          <h3 className="text-lg font-bold text-text-accent">Report for this week</h3>
          
          <div className="flex items-center gap-2">
            <div className="flex items-center bg-success-light rounded-xl">
              <button className="px-3 py-1 text-sm font-medium text-success-background bg-white rounded-base">
                This week
              </button>
              <button className="px-3 py-1 text-sm text-text-secondary">
                Last week
              </button>
            </div>
            <img src="/images/img_dotshorizontal.svg" alt="Options" className="w-5 h-5 ml-2" />
          </div>
        </div>

        {/* Stats Row */}
        <div className="flex flex-wrap gap-5 mb-10">
          <div className="flex flex-col gap-0.5 p-2 border-b-2 border-success-background bg-gradient-to-b from-transparent to-success-background/10">
            <span className="text-2xl font-bold text-text-accent">52k</span>
            <span className="text-sm font-medium text-text-muted">Customers</span>
          </div>
          <div className="flex flex-col gap-0.5 p-2 border-b border-primary-light">
            <span className="text-2xl font-bold text-text-accent">3.5k</span>
            <span className="text-sm font-medium text-text-muted">Total Products</span>
          </div>
          <div className="flex flex-col gap-0.5 p-2 border-b border-primary-light">
            <span className="text-2xl font-bold text-text-accent">2.5k</span>
            <span className="text-sm font-medium text-text-muted">Stock Products</span>
          </div>
          <div className="flex flex-col gap-0.5 p-2 border-b border-primary-light">
            <span className="text-2xl font-bold text-text-accent">0.5k</span>
            <span className="text-sm font-medium text-text-muted">Out of Stock</span>
          </div>
          <div className="flex flex-col gap-0.5 p-2 border-b border-primary-light">
            <span className="text-2xl font-bold text-text-accent">250k</span>
            <span className="text-sm font-medium text-text-muted">Revenue</span>
          </div>
        </div>

        {/* Chart */}
        <div className="w-full h-60">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={weeklyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Area 
                type="monotone" 
                dataKey="customers" 
                stroke="#4ea674" 
                fill="#4ea674" 
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
 
    </section>
  );
};

export default WeeklyReports;